import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getLoginUrl } from '../api';

export default function Login() {
  const [loading, setLoading]   = useState(false);
  const [searchParams]          = useSearchParams();
  const errorParam              = searchParams.get('error');

  const handleLogin = async () => {
    setLoading(true);
    try {
      const { data } = await getLoginUrl();
      window.location.href = data.auth_url;
    } catch {
      alert('Error al conectar con el servidor.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🏷️</div>
        <h1 style={{ fontSize:22, fontWeight:700, marginBottom:8 }}>Portal Comercial</h1>
        <p style={{ color:'var(--text-2)', fontSize:14, marginBottom: errorParam ? 16 : 32, lineHeight:1.5 }}>
          RD Printer Service · Ingresá con tu cuenta corporativa de Google.
        </p>
        {errorParam === 'dominio' && (
          <div style={{ background:'#fee', border:'1px solid var(--accent)', borderRadius:8, padding:'10px 14px', marginBottom:20, fontSize:13, color:'var(--accent)' }}>
            Solo se permiten cuentas <strong>@rdprinter.com</strong>.
          </div>
        )}
        {errorParam === 'inactivo' && (
          <div style={{ background:'#fee', border:'1px solid var(--accent)', borderRadius:8, padding:'10px 14px', marginBottom:20, fontSize:13, color:'var(--accent)' }}>
            Tu cuenta está <strong>desactivada</strong>. Contactá a un administrador.
          </div>
        )}
        <button className="btn btn-primary btn-lg"
          style={{ width:'100%', justifyContent:'center', gap:10 }}
          onClick={handleLogin} disabled={loading}>
          {loading
            ? <><span className="spinner" /> Redirigiendo…</>
            : <>
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <path fill="white" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="white" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="white" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="white" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Ingresar con Google
              </>
          }
        </button>
        <p style={{ marginTop:20, fontSize:12, color:'var(--text-3)' }}>Solo cuentas @rdprinter.com</p>
      </div>
    </div>
  );
}
